import { TableCell, Box } from '@mui/material'
import React from 'react'
import { CheckSuccess } from '../../../../constants/icons/CheckSuccess'
import { CampaignListDataType, EmailEventDetailsType, WhatsAppEventDetailsType } from '../../../../types/dataTypes'
import styled from '@emotion/styled'
import { COLOR_MAP } from '../../../../constants/ColorNames'
import { PillFilled } from '../../../../constants/icons/PillFilled'
import { MailSent } from '../../../../constants/icons/MailSent'
import { Time } from '../../../../constants/icons/Time'


type ScheduleType = {
    campaignStageData: any,
    campaignDetail: CampaignListDataType
}

const GreenPill = ({ percentage }: { percentage: number }) => {
    return (<Box sx={{
        width: '61px',
        height: '24px',
        backgroundColor: COLOR_MAP.GREEN_LIGHT,
        borderRadius: '18px',
        display: 'flex',
        position: 'relative',
        overflow: 'hidden'
    }}>
        <PillFilled percentage={percentage} />
        <Box sx={{ position: 'absolute', padding: '4px', display: 'flex', alignItems: 'center', gap: '8px', width: '61px' }}>
            <MailSent />
            <Box sx={{ fontSize: '10px', fontWeight: 600, color: 'white', lineHeight: '14px', letterSpacing: '0.4px' }}>
                {Math.floor(percentage)}%
            </Box>
        </Box>
    </Box>)
}

const emailEventIcon = (step: EmailEventDetailsType, isLastStep: boolean) => {
    const { totalUniqueEmail, totalUniqueEmailSent } = step;
    if (!step.totalUniqueEmail) {
        return (<Time width={isLastStep ? '61' : '24'} />)
    }
    else if (step.totalUniqueEmail === step.totalUniqueEmailSent) {
        return (<CheckSuccess width={isLastStep ? '61' : '24'} />)
    }
    else {
        const percentage = (totalUniqueEmail ? (totalUniqueEmailSent / totalUniqueEmail) : 0) * 100
        return (<GreenPill percentage={percentage} />)
    }
}

const whatsEventIcon = (step: WhatsAppEventDetailsType | WhatsAppEventDetailsType, isLastStep: boolean) => {
    const { assigned, completed } = step;
    if (!step.assigned) {
        return (<Time width={isLastStep ? '61' : '24'} />)
    }
    else if (step.assigned === step.completed) {
        return (<CheckSuccess width={isLastStep ? '61' : '24'} />)
    }
    else {
        const percentage = (assigned ? (completed / assigned) : 0) * 100
        return (<GreenPill percentage={percentage} />)
    }
}

const Schedule = ({ campaignStageData, campaignDetail }: ScheduleType) => {
    const { receiveReplyOnEmail, osType } = campaignDetail;
    const { emailEventDetails = [], sendingFrom = "", whatsAppCountryCode="", whatsAppNumber="", whatsAppEventDetails=[], whatsAppName="" } = campaignStageData || {};


    const isWhatsAppCampaign = osType?.toLowerCase() === "whatsapp";


    return (
        <TableCell sx={{ fontSize: '12px' }}>
            <Box sx={{ display: 'flex', paddingBottom: '16px', lineHeight: '16px', gap: '24px' }}>
                {isWhatsAppCampaign ? 
                <Box>
                    <span style={{ color: COLOR_MAP.GREY_1 }}>Sending from:</span> {whatsAppCountryCode ? "+": "" }{whatsAppCountryCode} {whatsAppNumber}  <span style={{ color: COLOR_MAP.GREY_1, marginLeft: '5px' }}>({whatsAppName})</span>
                    </Box>
                : <Box><span style={{ color: COLOR_MAP.GREY_1 }}>Sending from:</span> {sendingFrom}</Box>}
                {!isWhatsAppCampaign && <Box><span style={{ color: COLOR_MAP.GREY_1 }}>Receiving on:</span> {receiveReplyOnEmail}</Box>}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {!isWhatsAppCampaign && emailEventDetails?.map((step: EmailEventDetailsType, index: any) => (
                    <>
                        <Box key={index} sx={{ display: 'flex', flexDirection: 'column', position: 'relative', lineHeight: '20px', whiteSpace: 'nowrap' }}>
                            {emailEventIcon(step, index === emailEventDetails.length - 1)}
                            <Box sx={{ position: 'absolute', bottom: '-24px' }}>{step.stepName}</Box>
                            <Box sx={{ position: 'absolute', bottom: '-44px', color: COLOR_MAP.GREY_1 }}>{step.startDate}</Box>
                        </Box>
                        {(index !== emailEventDetails.length - 1) && (
                            <Box key={`line${index}`} sx={{ height: '1px', backgroundColor: COLOR_MAP.BORDER_GREY, flex: 1, minWidth: '61px' }}>
                                <Box sx={{ height: '1px', width: `${(step.totalUniqueEmail ? (step.totalUniqueEmailSent / step.totalUniqueEmail) : 0) * 100}%`, backgroundColor: COLOR_MAP.GREEN_LIGHT }}></Box>
                            </Box>
                        )}
                    </>
                ))}

                {/* For whats app  */}
                {isWhatsAppCampaign && whatsAppEventDetails?.map((step: WhatsAppEventDetailsType, index: any) => (
                    <>
                        <Box key={index} sx={{ display: 'flex', flexDirection: 'column', position: 'relative', lineHeight: '20px', whiteSpace: 'nowrap' }}>
                            {whatsEventIcon(step, index === whatsAppEventDetails.length - 1)}
                            <Box sx={{ position: 'absolute', bottom: '-24px' }}>{step.stepName}</Box>
                            <Box sx={{ position: 'absolute', bottom: '-44px', color: COLOR_MAP.GREY_1 }}>{step.startDate}</Box>
                        </Box>
                        {(index !== whatsAppEventDetails.length - 1) && (
                            <Box key={`line${index}`} sx={{ height: '1px', backgroundColor: COLOR_MAP.BORDER_GREY, flex: 1, minWidth: '61px' }}>
                                <Box sx={{ height: '1px', width: `${(step.assigned ? (step.completed / step.assigned) : 0) * 100}%`, backgroundColor: COLOR_MAP.GREEN_LIGHT }}></Box>
                            </Box>
                        )}
                    </>
                ))}
            </Box>

        </TableCell >
    )
}

export default Schedule